module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_8017.0ad3911e.png";